import { FormInstance } from '@models/global-forms';
import {
	MatterPackageContentType,
	MatterPackageContentDocumentType,
	MatterPackageContent,
	MatterPackageCustomizations,
} from '@models/matter-package';
import { MatterWordDocument } from '@models/matter-word-documents';
import { MatterWordDocumentWithMetadata } from '../matter-word-documents/matter-word-documents.selectors';

export class Create {
	static readonly type = '[matter-packages] create';
	constructor(
		public payload: {
			id?: string;
			packageName: string;
			documents?: (MatterWordDocumentWithMetadata & {
				contentType: MatterPackageContentType;
			})[];
			packageTemplateId?: string;
			packageHash?: string;
		},
	) {}
}

export class UpdateFieldValue {
	static readonly type =
		'[matter-packages] update field value of matter package';
	constructor(
		public payload: { id: string; fieldName: string; value: unknown },
	) {}
}

export class AddContent {
	static readonly type = '[matter-packages] add content';
	constructor(
		public docMetadata: {
			id: string;
			title: string;
			type: MatterPackageContentType;
			contentType: MatterPackageContentDocumentType;
			content: MatterWordDocument | FormInstance;
		},
		public duplicated?: boolean,
		public generated?: boolean,
	) {}
}

export class RemoveContent {
	static readonly type = '[matter-packages] remove content';
	constructor(public payload: { packageId: string; contentId: string }) {}
}

export class UpdatePackageName {
	static readonly type = '[matter-packages] update package name';
	constructor(public payload: { id: string; packageName: string }) {}
}

export class ReorderContent {
	static readonly type = '[Matter Packages] Reorder Content';
	constructor(
		public payload: {
			id: string;
			contentId: string;
			newIndex: number;
		},
	) {}
}

export class DeletePackage {
	static readonly type = '[matter-packages] delete package';
	constructor(public payload: { id: string }) {}
}

export class SelectPackage {
	static readonly type = '[matter-packages] select package';
	constructor(public payload: { id: string }) {}
}

export class ExportPackage {
	static readonly type = '[matter-packages] export package';
	constructor(public packageId: string) {}
}

export class TrackCustomization {
	static readonly type = '[matter-packages] track customization';
	constructor(
		public payload: {
			packageId: string;
			action: 'add' | 'remove';
			documentId: string;
		},
	) {}
}

export class SyncPackageContents {
	static readonly type = '[matter-packages] sync package contents';
	constructor(
		public payload: {
			packageId: string;
			contents: MatterPackageContent[];
			documents: MatterWordDocumentWithMetadata[];
			customizations: MatterPackageCustomizations;
		},
	) {}
}

export class SyncPackageWithVirtual {
	static readonly type = '[matter-packages] sync package with virtual';
	constructor(
		public payload: {
			matterPackageId: string;
			virtualPackageHash?: string;
			virtualContents?: MatterPackageContent[];
			virtualDocuments?: (MatterWordDocumentWithMetadata & { id: string })[];
		},
	) {}
}
